module.exports = __webpack_public_path__ + "img/Philippines-2-hover.d35074d9.jpg";